// source: v3/billing_entity_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var v3_types_billing_adjustment_pb = require('../v3/types/billing_adjustment_pb.js');
goog.object.extend(proto, v3_types_billing_adjustment_pb);
var v3_types_billing_entity_pb = require('../v3/types/billing_entity_pb.js');
goog.object.extend(proto, v3_types_billing_entity_pb);
var v3_types_billing_mechanism_pb = require('../v3/types/billing_mechanism_pb.js');
goog.object.extend(proto, v3_types_billing_mechanism_pb);
var v3_types_pagination_pb = require('../v3/types/pagination_pb.js');
goog.object.extend(proto, v3_types_pagination_pb);
var v3_types_purchased_product_pb = require('../v3/types/purchased_product_pb.js');
goog.object.extend(proto, v3_types_purchased_product_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.AddBillingAdjustmentResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.AssignPerCallDurationProductResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.AssignPerDdiProductRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.AssignPerDdiProductResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.CreateBillingEntityRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.CreateBillingEntityResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.ListBillingEntitiesRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.ListBillingEntitiesResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.RemoveBillingAdjustmentRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.RemoveBillingAdjustmentResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.RemoveBillingEntityRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.RemoveBillingEntityResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.UpdateBillingEntityRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.UpdateBillingEntityResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.ListBillingEntitiesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.ListBillingEntitiesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.ListBillingEntitiesRequest.displayName = 'proto.loopup.ctgateway.v3.ListBillingEntitiesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.ListBillingEntitiesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v3.ListBillingEntitiesResponse.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v3.ListBillingEntitiesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.ListBillingEntitiesResponse.displayName = 'proto.loopup.ctgateway.v3.ListBillingEntitiesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.CreateBillingEntityRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v3.CreateBillingEntityRequest.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v3.CreateBillingEntityRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.CreateBillingEntityRequest.displayName = 'proto.loopup.ctgateway.v3.CreateBillingEntityRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.CreateBillingEntityResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.CreateBillingEntityResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.CreateBillingEntityResponse.displayName = 'proto.loopup.ctgateway.v3.CreateBillingEntityResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v3.UpdateBillingEntityRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.displayName = 'proto.loopup.ctgateway.v3.UpdateBillingEntityRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.UpdateBillingEntityResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.UpdateBillingEntityResponse.displayName = 'proto.loopup.ctgateway.v3.UpdateBillingEntityResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest.displayName = 'proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductResponse.displayName = 'proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest.displayName = 'proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductResponse.displayName = 'proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest.displayName = 'proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.AssignPerCallDurationProductResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.AssignPerCallDurationProductResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.AssignPerCallDurationProductResponse.displayName = 'proto.loopup.ctgateway.v3.AssignPerCallDurationProductResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.AssignPerDdiProductRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.displayName = 'proto.loopup.ctgateway.v3.AssignPerDdiProductRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.AssignPerDdiProductResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.AssignPerDdiProductResponse.displayName = 'proto.loopup.ctgateway.v3.AssignPerDdiProductResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsRequest.displayName = 'proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsResponse.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsResponse.displayName = 'proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsRequest.displayName = 'proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsResponse.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsResponse.displayName = 'proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsRequest.displayName = 'proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsResponse.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsResponse.displayName = 'proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest.displayName = 'proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.AddBillingAdjustmentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.AddBillingAdjustmentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.AddBillingAdjustmentResponse.displayName = 'proto.loopup.ctgateway.v3.AddBillingAdjustmentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.RemoveBillingAdjustmentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.RemoveBillingAdjustmentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.RemoveBillingAdjustmentRequest.displayName = 'proto.loopup.ctgateway.v3.RemoveBillingAdjustmentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.RemoveBillingAdjustmentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.RemoveBillingAdjustmentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.RemoveBillingAdjustmentResponse.displayName = 'proto.loopup.ctgateway.v3.RemoveBillingAdjustmentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.RemoveBillingEntityRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.RemoveBillingEntityRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.RemoveBillingEntityRequest.displayName = 'proto.loopup.ctgateway.v3.RemoveBillingEntityRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.RemoveBillingEntityResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.RemoveBillingEntityResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.RemoveBillingEntityResponse.displayName = 'proto.loopup.ctgateway.v3.RemoveBillingEntityResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.ListBillingEntitiesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.ListBillingEntitiesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.ListBillingEntitiesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListBillingEntitiesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    customerId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.ListBillingEntitiesRequest}
 */
proto.loopup.ctgateway.v3.ListBillingEntitiesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.ListBillingEntitiesRequest;
  return proto.loopup.ctgateway.v3.ListBillingEntitiesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.ListBillingEntitiesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.ListBillingEntitiesRequest}
 */
proto.loopup.ctgateway.v3.ListBillingEntitiesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.ListBillingEntitiesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.ListBillingEntitiesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.ListBillingEntitiesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListBillingEntitiesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCustomerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string customer_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.ListBillingEntitiesRequest.prototype.getCustomerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.ListBillingEntitiesRequest} returns this
 */
proto.loopup.ctgateway.v3.ListBillingEntitiesRequest.prototype.setCustomerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.loopup.ctgateway.v3.ListBillingEntitiesRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.ListBillingEntitiesRequest} returns this
 */
proto.loopup.ctgateway.v3.ListBillingEntitiesRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 page_size = 3;
 * @return {number}
 */
proto.loopup.ctgateway.v3.ListBillingEntitiesRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.ListBillingEntitiesRequest} returns this
 */
proto.loopup.ctgateway.v3.ListBillingEntitiesRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v3.ListBillingEntitiesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.ListBillingEntitiesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.ListBillingEntitiesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.ListBillingEntitiesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListBillingEntitiesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingEntityList: jspb.Message.toObjectList(msg.getBillingEntityList(),
    v3_types_billing_entity_pb.BillingEntity.toObject, includeInstance),
    paginationInfo: (f = msg.getPaginationInfo()) && v3_types_pagination_pb.PaginationInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.ListBillingEntitiesResponse}
 */
proto.loopup.ctgateway.v3.ListBillingEntitiesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.ListBillingEntitiesResponse;
  return proto.loopup.ctgateway.v3.ListBillingEntitiesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.ListBillingEntitiesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.ListBillingEntitiesResponse}
 */
proto.loopup.ctgateway.v3.ListBillingEntitiesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v3_types_billing_entity_pb.BillingEntity;
      reader.readMessage(value,v3_types_billing_entity_pb.BillingEntity.deserializeBinaryFromReader);
      msg.addBillingEntity(value);
      break;
    case 2:
      var value = new v3_types_pagination_pb.PaginationInfo;
      reader.readMessage(value,v3_types_pagination_pb.PaginationInfo.deserializeBinaryFromReader);
      msg.setPaginationInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.ListBillingEntitiesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.ListBillingEntitiesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.ListBillingEntitiesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListBillingEntitiesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingEntityList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      v3_types_billing_entity_pb.BillingEntity.serializeBinaryToWriter
    );
  }
  f = message.getPaginationInfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      v3_types_pagination_pb.PaginationInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated BillingEntity billing_entity = 1;
 * @return {!Array<!proto.loopup.ctgateway.v3.BillingEntity>}
 */
proto.loopup.ctgateway.v3.ListBillingEntitiesResponse.prototype.getBillingEntityList = function() {
  return /** @type{!Array<!proto.loopup.ctgateway.v3.BillingEntity>} */ (
    jspb.Message.getRepeatedWrapperField(this, v3_types_billing_entity_pb.BillingEntity, 1));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v3.BillingEntity>} value
 * @return {!proto.loopup.ctgateway.v3.ListBillingEntitiesResponse} returns this
*/
proto.loopup.ctgateway.v3.ListBillingEntitiesResponse.prototype.setBillingEntityList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.loopup.ctgateway.v3.BillingEntity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v3.BillingEntity}
 */
proto.loopup.ctgateway.v3.ListBillingEntitiesResponse.prototype.addBillingEntity = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.loopup.ctgateway.v3.BillingEntity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v3.ListBillingEntitiesResponse} returns this
 */
proto.loopup.ctgateway.v3.ListBillingEntitiesResponse.prototype.clearBillingEntityList = function() {
  return this.setBillingEntityList([]);
};


/**
 * optional PaginationInfo pagination_info = 2;
 * @return {?proto.loopup.ctgateway.v3.PaginationInfo}
 */
proto.loopup.ctgateway.v3.ListBillingEntitiesResponse.prototype.getPaginationInfo = function() {
  return /** @type{?proto.loopup.ctgateway.v3.PaginationInfo} */ (
    jspb.Message.getWrapperField(this, v3_types_pagination_pb.PaginationInfo, 2));
};


/**
 * @param {?proto.loopup.ctgateway.v3.PaginationInfo|undefined} value
 * @return {!proto.loopup.ctgateway.v3.ListBillingEntitiesResponse} returns this
*/
proto.loopup.ctgateway.v3.ListBillingEntitiesResponse.prototype.setPaginationInfo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.ListBillingEntitiesResponse} returns this
 */
proto.loopup.ctgateway.v3.ListBillingEntitiesResponse.prototype.clearPaginationInfo = function() {
  return this.setPaginationInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.ListBillingEntitiesResponse.prototype.hasPaginationInfo = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v3.CreateBillingEntityRequest.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.CreateBillingEntityRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.CreateBillingEntityRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.CreateBillingEntityRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.CreateBillingEntityRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    customerId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    currencyCode: jspb.Message.getFieldWithDefault(msg, 3, ""),
    postalAddress: (f = msg.getPostalAddress()) && v3_types_billing_entity_pb.PostalAddress.toObject(includeInstance, f),
    billingContact: (f = msg.getBillingContact()) && v3_types_billing_entity_pb.BillingContact.toObject(includeInstance, f),
    emailRecipientsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    purchaseOrderReference: (f = msg.getPurchaseOrderReference()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    taxId: (f = msg.getTaxId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.CreateBillingEntityRequest}
 */
proto.loopup.ctgateway.v3.CreateBillingEntityRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.CreateBillingEntityRequest;
  return proto.loopup.ctgateway.v3.CreateBillingEntityRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.CreateBillingEntityRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.CreateBillingEntityRequest}
 */
proto.loopup.ctgateway.v3.CreateBillingEntityRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrencyCode(value);
      break;
    case 4:
      var value = new v3_types_billing_entity_pb.PostalAddress;
      reader.readMessage(value,v3_types_billing_entity_pb.PostalAddress.deserializeBinaryFromReader);
      msg.setPostalAddress(value);
      break;
    case 5:
      var value = new v3_types_billing_entity_pb.BillingContact;
      reader.readMessage(value,v3_types_billing_entity_pb.BillingContact.deserializeBinaryFromReader);
      msg.setBillingContact(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addEmailRecipients(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPurchaseOrderReference(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setTaxId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.CreateBillingEntityRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.CreateBillingEntityRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.CreateBillingEntityRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.CreateBillingEntityRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCustomerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCurrencyCode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPostalAddress();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      v3_types_billing_entity_pb.PostalAddress.serializeBinaryToWriter
    );
  }
  f = message.getBillingContact();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      v3_types_billing_entity_pb.BillingContact.serializeBinaryToWriter
    );
  }
  f = message.getEmailRecipientsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getPurchaseOrderReference();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTaxId();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string customer_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.CreateBillingEntityRequest.prototype.getCustomerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.CreateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v3.CreateBillingEntityRequest.prototype.setCustomerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.loopup.ctgateway.v3.CreateBillingEntityRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.CreateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v3.CreateBillingEntityRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string currency_code = 3;
 * @return {string}
 */
proto.loopup.ctgateway.v3.CreateBillingEntityRequest.prototype.getCurrencyCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.CreateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v3.CreateBillingEntityRequest.prototype.setCurrencyCode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional PostalAddress postal_address = 4;
 * @return {?proto.loopup.ctgateway.v3.PostalAddress}
 */
proto.loopup.ctgateway.v3.CreateBillingEntityRequest.prototype.getPostalAddress = function() {
  return /** @type{?proto.loopup.ctgateway.v3.PostalAddress} */ (
    jspb.Message.getWrapperField(this, v3_types_billing_entity_pb.PostalAddress, 4));
};


/**
 * @param {?proto.loopup.ctgateway.v3.PostalAddress|undefined} value
 * @return {!proto.loopup.ctgateway.v3.CreateBillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v3.CreateBillingEntityRequest.prototype.setPostalAddress = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.CreateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v3.CreateBillingEntityRequest.prototype.clearPostalAddress = function() {
  return this.setPostalAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.CreateBillingEntityRequest.prototype.hasPostalAddress = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional BillingContact billing_contact = 5;
 * @return {?proto.loopup.ctgateway.v3.BillingContact}
 */
proto.loopup.ctgateway.v3.CreateBillingEntityRequest.prototype.getBillingContact = function() {
  return /** @type{?proto.loopup.ctgateway.v3.BillingContact} */ (
    jspb.Message.getWrapperField(this, v3_types_billing_entity_pb.BillingContact, 5));
};


/**
 * @param {?proto.loopup.ctgateway.v3.BillingContact|undefined} value
 * @return {!proto.loopup.ctgateway.v3.CreateBillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v3.CreateBillingEntityRequest.prototype.setBillingContact = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.CreateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v3.CreateBillingEntityRequest.prototype.clearBillingContact = function() {
  return this.setBillingContact(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.CreateBillingEntityRequest.prototype.hasBillingContact = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * repeated string email_recipients = 6;
 * @return {!Array<string>}
 */
proto.loopup.ctgateway.v3.CreateBillingEntityRequest.prototype.getEmailRecipientsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.loopup.ctgateway.v3.CreateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v3.CreateBillingEntityRequest.prototype.setEmailRecipientsList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v3.CreateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v3.CreateBillingEntityRequest.prototype.addEmailRecipients = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v3.CreateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v3.CreateBillingEntityRequest.prototype.clearEmailRecipientsList = function() {
  return this.setEmailRecipientsList([]);
};


/**
 * optional google.protobuf.StringValue purchase_order_reference = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v3.CreateBillingEntityRequest.prototype.getPurchaseOrderReference = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v3.CreateBillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v3.CreateBillingEntityRequest.prototype.setPurchaseOrderReference = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.CreateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v3.CreateBillingEntityRequest.prototype.clearPurchaseOrderReference = function() {
  return this.setPurchaseOrderReference(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.CreateBillingEntityRequest.prototype.hasPurchaseOrderReference = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.StringValue tax_id = 8;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v3.CreateBillingEntityRequest.prototype.getTaxId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 8));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v3.CreateBillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v3.CreateBillingEntityRequest.prototype.setTaxId = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.CreateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v3.CreateBillingEntityRequest.prototype.clearTaxId = function() {
  return this.setTaxId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.CreateBillingEntityRequest.prototype.hasTaxId = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.CreateBillingEntityResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.CreateBillingEntityResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.CreateBillingEntityResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.CreateBillingEntityResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingEntity: (f = msg.getBillingEntity()) && v3_types_billing_entity_pb.BillingEntity.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.CreateBillingEntityResponse}
 */
proto.loopup.ctgateway.v3.CreateBillingEntityResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.CreateBillingEntityResponse;
  return proto.loopup.ctgateway.v3.CreateBillingEntityResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.CreateBillingEntityResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.CreateBillingEntityResponse}
 */
proto.loopup.ctgateway.v3.CreateBillingEntityResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v3_types_billing_entity_pb.BillingEntity;
      reader.readMessage(value,v3_types_billing_entity_pb.BillingEntity.deserializeBinaryFromReader);
      msg.setBillingEntity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.CreateBillingEntityResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.CreateBillingEntityResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.CreateBillingEntityResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.CreateBillingEntityResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingEntity();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      v3_types_billing_entity_pb.BillingEntity.serializeBinaryToWriter
    );
  }
};


/**
 * optional BillingEntity billing_entity = 1;
 * @return {?proto.loopup.ctgateway.v3.BillingEntity}
 */
proto.loopup.ctgateway.v3.CreateBillingEntityResponse.prototype.getBillingEntity = function() {
  return /** @type{?proto.loopup.ctgateway.v3.BillingEntity} */ (
    jspb.Message.getWrapperField(this, v3_types_billing_entity_pb.BillingEntity, 1));
};


/**
 * @param {?proto.loopup.ctgateway.v3.BillingEntity|undefined} value
 * @return {!proto.loopup.ctgateway.v3.CreateBillingEntityResponse} returns this
*/
proto.loopup.ctgateway.v3.CreateBillingEntityResponse.prototype.setBillingEntity = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.CreateBillingEntityResponse} returns this
 */
proto.loopup.ctgateway.v3.CreateBillingEntityResponse.prototype.clearBillingEntity = function() {
  return this.setBillingEntity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.CreateBillingEntityResponse.prototype.hasBillingEntity = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.UpdateBillingEntityRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingEntityId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    currencyCode: jspb.Message.getFieldWithDefault(msg, 3, ""),
    postalAddress: (f = msg.getPostalAddress()) && v3_types_billing_entity_pb.PostalAddress.toObject(includeInstance, f),
    billingContact: (f = msg.getBillingContact()) && v3_types_billing_entity_pb.BillingContact.toObject(includeInstance, f),
    emailRecipientsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    purchaseOrderReference: (f = msg.getPurchaseOrderReference()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    taxId: (f = msg.getTaxId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.UpdateBillingEntityRequest}
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.UpdateBillingEntityRequest;
  return proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.UpdateBillingEntityRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.UpdateBillingEntityRequest}
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingEntityId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrencyCode(value);
      break;
    case 4:
      var value = new v3_types_billing_entity_pb.PostalAddress;
      reader.readMessage(value,v3_types_billing_entity_pb.PostalAddress.deserializeBinaryFromReader);
      msg.setPostalAddress(value);
      break;
    case 5:
      var value = new v3_types_billing_entity_pb.BillingContact;
      reader.readMessage(value,v3_types_billing_entity_pb.BillingContact.deserializeBinaryFromReader);
      msg.setBillingContact(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addEmailRecipients(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPurchaseOrderReference(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setTaxId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.UpdateBillingEntityRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingEntityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCurrencyCode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPostalAddress();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      v3_types_billing_entity_pb.PostalAddress.serializeBinaryToWriter
    );
  }
  f = message.getBillingContact();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      v3_types_billing_entity_pb.BillingContact.serializeBinaryToWriter
    );
  }
  f = message.getEmailRecipientsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getPurchaseOrderReference();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTaxId();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string billing_entity_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.prototype.getBillingEntityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.UpdateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.prototype.setBillingEntityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.UpdateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string currency_code = 3;
 * @return {string}
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.prototype.getCurrencyCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.UpdateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.prototype.setCurrencyCode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional PostalAddress postal_address = 4;
 * @return {?proto.loopup.ctgateway.v3.PostalAddress}
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.prototype.getPostalAddress = function() {
  return /** @type{?proto.loopup.ctgateway.v3.PostalAddress} */ (
    jspb.Message.getWrapperField(this, v3_types_billing_entity_pb.PostalAddress, 4));
};


/**
 * @param {?proto.loopup.ctgateway.v3.PostalAddress|undefined} value
 * @return {!proto.loopup.ctgateway.v3.UpdateBillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.prototype.setPostalAddress = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.UpdateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.prototype.clearPostalAddress = function() {
  return this.setPostalAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.prototype.hasPostalAddress = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional BillingContact billing_contact = 5;
 * @return {?proto.loopup.ctgateway.v3.BillingContact}
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.prototype.getBillingContact = function() {
  return /** @type{?proto.loopup.ctgateway.v3.BillingContact} */ (
    jspb.Message.getWrapperField(this, v3_types_billing_entity_pb.BillingContact, 5));
};


/**
 * @param {?proto.loopup.ctgateway.v3.BillingContact|undefined} value
 * @return {!proto.loopup.ctgateway.v3.UpdateBillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.prototype.setBillingContact = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.UpdateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.prototype.clearBillingContact = function() {
  return this.setBillingContact(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.prototype.hasBillingContact = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * repeated string email_recipients = 6;
 * @return {!Array<string>}
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.prototype.getEmailRecipientsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.loopup.ctgateway.v3.UpdateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.prototype.setEmailRecipientsList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v3.UpdateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.prototype.addEmailRecipients = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v3.UpdateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.prototype.clearEmailRecipientsList = function() {
  return this.setEmailRecipientsList([]);
};


/**
 * optional google.protobuf.StringValue purchase_order_reference = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.prototype.getPurchaseOrderReference = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v3.UpdateBillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.prototype.setPurchaseOrderReference = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.UpdateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.prototype.clearPurchaseOrderReference = function() {
  return this.setPurchaseOrderReference(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.prototype.hasPurchaseOrderReference = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.StringValue tax_id = 8;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.prototype.getTaxId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 8));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v3.UpdateBillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.prototype.setTaxId = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.UpdateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.prototype.clearTaxId = function() {
  return this.setTaxId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityRequest.prototype.hasTaxId = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.UpdateBillingEntityResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.UpdateBillingEntityResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingEntity: (f = msg.getBillingEntity()) && v3_types_billing_entity_pb.BillingEntity.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.UpdateBillingEntityResponse}
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.UpdateBillingEntityResponse;
  return proto.loopup.ctgateway.v3.UpdateBillingEntityResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.UpdateBillingEntityResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.UpdateBillingEntityResponse}
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v3_types_billing_entity_pb.BillingEntity;
      reader.readMessage(value,v3_types_billing_entity_pb.BillingEntity.deserializeBinaryFromReader);
      msg.setBillingEntity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.UpdateBillingEntityResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.UpdateBillingEntityResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingEntity();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      v3_types_billing_entity_pb.BillingEntity.serializeBinaryToWriter
    );
  }
};


/**
 * optional BillingEntity billing_entity = 1;
 * @return {?proto.loopup.ctgateway.v3.BillingEntity}
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityResponse.prototype.getBillingEntity = function() {
  return /** @type{?proto.loopup.ctgateway.v3.BillingEntity} */ (
    jspb.Message.getWrapperField(this, v3_types_billing_entity_pb.BillingEntity, 1));
};


/**
 * @param {?proto.loopup.ctgateway.v3.BillingEntity|undefined} value
 * @return {!proto.loopup.ctgateway.v3.UpdateBillingEntityResponse} returns this
*/
proto.loopup.ctgateway.v3.UpdateBillingEntityResponse.prototype.setBillingEntity = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.UpdateBillingEntityResponse} returns this
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityResponse.prototype.clearBillingEntity = function() {
  return this.setBillingEntity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.UpdateBillingEntityResponse.prototype.hasBillingEntity = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingEntityId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sku: jspb.Message.getFieldWithDefault(msg, 2, ""),
    quantity: jspb.Message.getFieldWithDefault(msg, 3, 0),
    price: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    purchaseOrderReference: (f = msg.getPurchaseOrderReference()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    effectiveFromDateTime: (f = msg.getEffectiveFromDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    endDateTime: (f = msg.getEndDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest}
 */
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest;
  return proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest}
 */
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingEntityId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSku(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPrice(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPurchaseOrderReference(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEffectiveFromDateTime(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndDateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingEntityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSku();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getPurchaseOrderReference();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getEffectiveFromDateTime();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndDateTime();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string billing_entity_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest.prototype.getBillingEntityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest} returns this
 */
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest.prototype.setBillingEntityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string sku = 2;
 * @return {string}
 */
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest.prototype.getSku = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest} returns this
 */
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest.prototype.setSku = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 quantity = 3;
 * @return {number}
 */
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest} returns this
 */
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional double price = 4;
 * @return {number}
 */
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest} returns this
 */
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest.prototype.setPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional google.protobuf.StringValue purchase_order_reference = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest.prototype.getPurchaseOrderReference = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest} returns this
*/
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest.prototype.setPurchaseOrderReference = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest} returns this
 */
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest.prototype.clearPurchaseOrderReference = function() {
  return this.setPurchaseOrderReference(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest.prototype.hasPurchaseOrderReference = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Timestamp effective_from_date_time = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest.prototype.getEffectiveFromDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest} returns this
*/
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest.prototype.setEffectiveFromDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest} returns this
 */
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest.prototype.clearEffectiveFromDateTime = function() {
  return this.setEffectiveFromDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest.prototype.hasEffectiveFromDateTime = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.Timestamp end_date_time = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest.prototype.getEndDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest} returns this
*/
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest.prototype.setEndDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest} returns this
 */
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest.prototype.clearEndDateTime = function() {
  return this.setEndDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductRequest.prototype.hasEndDateTime = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    purchasedProduct: (f = msg.getPurchasedProduct()) && v3_types_purchased_product_pb.PerSpecifiedQuantityPurchasedProduct.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductResponse}
 */
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductResponse;
  return proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductResponse}
 */
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v3_types_purchased_product_pb.PerSpecifiedQuantityPurchasedProduct;
      reader.readMessage(value,v3_types_purchased_product_pb.PerSpecifiedQuantityPurchasedProduct.deserializeBinaryFromReader);
      msg.setPurchasedProduct(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPurchasedProduct();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      v3_types_purchased_product_pb.PerSpecifiedQuantityPurchasedProduct.serializeBinaryToWriter
    );
  }
};


/**
 * optional PerSpecifiedQuantityPurchasedProduct purchased_product = 1;
 * @return {?proto.loopup.ctgateway.v3.PerSpecifiedQuantityPurchasedProduct}
 */
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductResponse.prototype.getPurchasedProduct = function() {
  return /** @type{?proto.loopup.ctgateway.v3.PerSpecifiedQuantityPurchasedProduct} */ (
    jspb.Message.getWrapperField(this, v3_types_purchased_product_pb.PerSpecifiedQuantityPurchasedProduct, 1));
};


/**
 * @param {?proto.loopup.ctgateway.v3.PerSpecifiedQuantityPurchasedProduct|undefined} value
 * @return {!proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductResponse} returns this
*/
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductResponse.prototype.setPurchasedProduct = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductResponse} returns this
 */
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductResponse.prototype.clearPurchasedProduct = function() {
  return this.setPurchasedProduct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.AssignRecurringPerSpecifiedQuantityProductResponse.prototype.hasPurchasedProduct = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingEntityId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sku: jspb.Message.getFieldWithDefault(msg, 2, ""),
    quantity: jspb.Message.getFieldWithDefault(msg, 3, 0),
    price: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    purchaseOrderReference: (f = msg.getPurchaseOrderReference()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    effectiveFromDateTime: (f = msg.getEffectiveFromDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest}
 */
proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest;
  return proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest}
 */
proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingEntityId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSku(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPrice(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPurchaseOrderReference(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEffectiveFromDateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingEntityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSku();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getPurchaseOrderReference();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getEffectiveFromDateTime();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string billing_entity_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest.prototype.getBillingEntityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest} returns this
 */
proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest.prototype.setBillingEntityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string sku = 2;
 * @return {string}
 */
proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest.prototype.getSku = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest} returns this
 */
proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest.prototype.setSku = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 quantity = 3;
 * @return {number}
 */
proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest} returns this
 */
proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional double price = 4;
 * @return {number}
 */
proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest} returns this
 */
proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest.prototype.setPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional google.protobuf.StringValue purchase_order_reference = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest.prototype.getPurchaseOrderReference = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest} returns this
*/
proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest.prototype.setPurchaseOrderReference = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest} returns this
 */
proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest.prototype.clearPurchaseOrderReference = function() {
  return this.setPurchaseOrderReference(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest.prototype.hasPurchaseOrderReference = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Timestamp effective_from_date_time = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest.prototype.getEffectiveFromDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest} returns this
*/
proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest.prototype.setEffectiveFromDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest} returns this
 */
proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest.prototype.clearEffectiveFromDateTime = function() {
  return this.setEffectiveFromDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductRequest.prototype.hasEffectiveFromDateTime = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    purchasedProduct: (f = msg.getPurchasedProduct()) && v3_types_purchased_product_pb.PerSpecifiedQuantityPurchasedProduct.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductResponse}
 */
proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductResponse;
  return proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductResponse}
 */
proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v3_types_purchased_product_pb.PerSpecifiedQuantityPurchasedProduct;
      reader.readMessage(value,v3_types_purchased_product_pb.PerSpecifiedQuantityPurchasedProduct.deserializeBinaryFromReader);
      msg.setPurchasedProduct(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPurchasedProduct();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      v3_types_purchased_product_pb.PerSpecifiedQuantityPurchasedProduct.serializeBinaryToWriter
    );
  }
};


/**
 * optional PerSpecifiedQuantityPurchasedProduct purchased_product = 1;
 * @return {?proto.loopup.ctgateway.v3.PerSpecifiedQuantityPurchasedProduct}
 */
proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductResponse.prototype.getPurchasedProduct = function() {
  return /** @type{?proto.loopup.ctgateway.v3.PerSpecifiedQuantityPurchasedProduct} */ (
    jspb.Message.getWrapperField(this, v3_types_purchased_product_pb.PerSpecifiedQuantityPurchasedProduct, 1));
};


/**
 * @param {?proto.loopup.ctgateway.v3.PerSpecifiedQuantityPurchasedProduct|undefined} value
 * @return {!proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductResponse} returns this
*/
proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductResponse.prototype.setPurchasedProduct = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductResponse} returns this
 */
proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductResponse.prototype.clearPurchasedProduct = function() {
  return this.setPurchasedProduct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.AssignOneOffPerSpecifiedQuantityProductResponse.prototype.hasPurchasedProduct = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingEntityId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sku: jspb.Message.getFieldWithDefault(msg, 2, ""),
    purchaseOrderReference: (f = msg.getPurchaseOrderReference()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    effectiveFromDateTime: (f = msg.getEffectiveFromDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    endDateTime: (f = msg.getEndDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest}
 */
proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest;
  return proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest}
 */
proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingEntityId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSku(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPurchaseOrderReference(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEffectiveFromDateTime(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndDateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingEntityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSku();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPurchaseOrderReference();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getEffectiveFromDateTime();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndDateTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string billing_entity_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest.prototype.getBillingEntityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest} returns this
 */
proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest.prototype.setBillingEntityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string sku = 2;
 * @return {string}
 */
proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest.prototype.getSku = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest} returns this
 */
proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest.prototype.setSku = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.StringValue purchase_order_reference = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest.prototype.getPurchaseOrderReference = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest} returns this
*/
proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest.prototype.setPurchaseOrderReference = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest} returns this
 */
proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest.prototype.clearPurchaseOrderReference = function() {
  return this.setPurchaseOrderReference(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest.prototype.hasPurchaseOrderReference = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp effective_from_date_time = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest.prototype.getEffectiveFromDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest} returns this
*/
proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest.prototype.setEffectiveFromDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest} returns this
 */
proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest.prototype.clearEffectiveFromDateTime = function() {
  return this.setEffectiveFromDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest.prototype.hasEffectiveFromDateTime = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp end_date_time = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest.prototype.getEndDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest} returns this
*/
proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest.prototype.setEndDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest} returns this
 */
proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest.prototype.clearEndDateTime = function() {
  return this.setEndDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.AssignPerCallDurationProductRequest.prototype.hasEndDateTime = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.AssignPerCallDurationProductResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.AssignPerCallDurationProductResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.AssignPerCallDurationProductResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.AssignPerCallDurationProductResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    purchasedProduct: (f = msg.getPurchasedProduct()) && v3_types_purchased_product_pb.PerCallDurationPurchasedProduct.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.AssignPerCallDurationProductResponse}
 */
proto.loopup.ctgateway.v3.AssignPerCallDurationProductResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.AssignPerCallDurationProductResponse;
  return proto.loopup.ctgateway.v3.AssignPerCallDurationProductResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.AssignPerCallDurationProductResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.AssignPerCallDurationProductResponse}
 */
proto.loopup.ctgateway.v3.AssignPerCallDurationProductResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v3_types_purchased_product_pb.PerCallDurationPurchasedProduct;
      reader.readMessage(value,v3_types_purchased_product_pb.PerCallDurationPurchasedProduct.deserializeBinaryFromReader);
      msg.setPurchasedProduct(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.AssignPerCallDurationProductResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.AssignPerCallDurationProductResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.AssignPerCallDurationProductResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.AssignPerCallDurationProductResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPurchasedProduct();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      v3_types_purchased_product_pb.PerCallDurationPurchasedProduct.serializeBinaryToWriter
    );
  }
};


/**
 * optional PerCallDurationPurchasedProduct purchased_product = 1;
 * @return {?proto.loopup.ctgateway.v3.PerCallDurationPurchasedProduct}
 */
proto.loopup.ctgateway.v3.AssignPerCallDurationProductResponse.prototype.getPurchasedProduct = function() {
  return /** @type{?proto.loopup.ctgateway.v3.PerCallDurationPurchasedProduct} */ (
    jspb.Message.getWrapperField(this, v3_types_purchased_product_pb.PerCallDurationPurchasedProduct, 1));
};


/**
 * @param {?proto.loopup.ctgateway.v3.PerCallDurationPurchasedProduct|undefined} value
 * @return {!proto.loopup.ctgateway.v3.AssignPerCallDurationProductResponse} returns this
*/
proto.loopup.ctgateway.v3.AssignPerCallDurationProductResponse.prototype.setPurchasedProduct = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.AssignPerCallDurationProductResponse} returns this
 */
proto.loopup.ctgateway.v3.AssignPerCallDurationProductResponse.prototype.clearPurchasedProduct = function() {
  return this.setPurchasedProduct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.AssignPerCallDurationProductResponse.prototype.hasPurchasedProduct = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.AssignPerDdiProductRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingEntityId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    price: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    minimumQuantity: jspb.Message.getFieldWithDefault(msg, 3, 0),
    contributingDdiActivationStatus: jspb.Message.getFieldWithDefault(msg, 4, 0),
    effectiveFromDateTime: (f = msg.getEffectiveFromDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    endDateTime: (f = msg.getEndDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    purchaseOrderReference: (f = msg.getPurchaseOrderReference()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    sku: jspb.Message.getFieldWithDefault(msg, 8, ""),
    billingMechanism: (f = msg.getBillingMechanism()) && v3_types_billing_mechanism_pb.BillingMechanism.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.AssignPerDdiProductRequest}
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.AssignPerDdiProductRequest;
  return proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.AssignPerDdiProductRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.AssignPerDdiProductRequest}
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingEntityId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPrice(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinimumQuantity(value);
      break;
    case 4:
      var value = /** @type {!proto.loopup.ctgateway.v3.ContributingDdiActivationStatus} */ (reader.readEnum());
      msg.setContributingDdiActivationStatus(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEffectiveFromDateTime(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndDateTime(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPurchaseOrderReference(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setSku(value);
      break;
    case 9:
      var value = new v3_types_billing_mechanism_pb.BillingMechanism;
      reader.readMessage(value,v3_types_billing_mechanism_pb.BillingMechanism.deserializeBinaryFromReader);
      msg.setBillingMechanism(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.AssignPerDdiProductRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingEntityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getMinimumQuantity();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getContributingDdiActivationStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getEffectiveFromDateTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndDateTime();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPurchaseOrderReference();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSku();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getBillingMechanism();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      v3_types_billing_mechanism_pb.BillingMechanism.serializeBinaryToWriter
    );
  }
};


/**
 * optional string billing_entity_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.prototype.getBillingEntityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.AssignPerDdiProductRequest} returns this
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.prototype.setBillingEntityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double price = 2;
 * @return {number}
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.AssignPerDdiProductRequest} returns this
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.prototype.setPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional int32 minimum_quantity = 3;
 * @return {number}
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.prototype.getMinimumQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.AssignPerDdiProductRequest} returns this
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.prototype.setMinimumQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional ContributingDdiActivationStatus contributing_ddi_activation_status = 4;
 * @return {!proto.loopup.ctgateway.v3.ContributingDdiActivationStatus}
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.prototype.getContributingDdiActivationStatus = function() {
  return /** @type {!proto.loopup.ctgateway.v3.ContributingDdiActivationStatus} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v3.ContributingDdiActivationStatus} value
 * @return {!proto.loopup.ctgateway.v3.AssignPerDdiProductRequest} returns this
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.prototype.setContributingDdiActivationStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp effective_from_date_time = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.prototype.getEffectiveFromDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v3.AssignPerDdiProductRequest} returns this
*/
proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.prototype.setEffectiveFromDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.AssignPerDdiProductRequest} returns this
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.prototype.clearEffectiveFromDateTime = function() {
  return this.setEffectiveFromDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.prototype.hasEffectiveFromDateTime = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Timestamp end_date_time = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.prototype.getEndDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v3.AssignPerDdiProductRequest} returns this
*/
proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.prototype.setEndDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.AssignPerDdiProductRequest} returns this
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.prototype.clearEndDateTime = function() {
  return this.setEndDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.prototype.hasEndDateTime = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.StringValue purchase_order_reference = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.prototype.getPurchaseOrderReference = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v3.AssignPerDdiProductRequest} returns this
*/
proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.prototype.setPurchaseOrderReference = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.AssignPerDdiProductRequest} returns this
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.prototype.clearPurchaseOrderReference = function() {
  return this.setPurchaseOrderReference(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.prototype.hasPurchaseOrderReference = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string sku = 8;
 * @return {string}
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.prototype.getSku = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.AssignPerDdiProductRequest} returns this
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.prototype.setSku = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional BillingMechanism billing_mechanism = 9;
 * @return {?proto.loopup.ctgateway.v3.BillingMechanism}
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.prototype.getBillingMechanism = function() {
  return /** @type{?proto.loopup.ctgateway.v3.BillingMechanism} */ (
    jspb.Message.getWrapperField(this, v3_types_billing_mechanism_pb.BillingMechanism, 9));
};


/**
 * @param {?proto.loopup.ctgateway.v3.BillingMechanism|undefined} value
 * @return {!proto.loopup.ctgateway.v3.AssignPerDdiProductRequest} returns this
*/
proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.prototype.setBillingMechanism = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.AssignPerDdiProductRequest} returns this
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.prototype.clearBillingMechanism = function() {
  return this.setBillingMechanism(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductRequest.prototype.hasBillingMechanism = function() {
  return jspb.Message.getField(this, 9) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.AssignPerDdiProductResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.AssignPerDdiProductResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    purchasedProduct: (f = msg.getPurchasedProduct()) && v3_types_purchased_product_pb.PerDdiPurchasedProduct.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.AssignPerDdiProductResponse}
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.AssignPerDdiProductResponse;
  return proto.loopup.ctgateway.v3.AssignPerDdiProductResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.AssignPerDdiProductResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.AssignPerDdiProductResponse}
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v3_types_purchased_product_pb.PerDdiPurchasedProduct;
      reader.readMessage(value,v3_types_purchased_product_pb.PerDdiPurchasedProduct.deserializeBinaryFromReader);
      msg.setPurchasedProduct(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.AssignPerDdiProductResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.AssignPerDdiProductResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPurchasedProduct();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      v3_types_purchased_product_pb.PerDdiPurchasedProduct.serializeBinaryToWriter
    );
  }
};


/**
 * optional PerDdiPurchasedProduct purchased_product = 1;
 * @return {?proto.loopup.ctgateway.v3.PerDdiPurchasedProduct}
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductResponse.prototype.getPurchasedProduct = function() {
  return /** @type{?proto.loopup.ctgateway.v3.PerDdiPurchasedProduct} */ (
    jspb.Message.getWrapperField(this, v3_types_purchased_product_pb.PerDdiPurchasedProduct, 1));
};


/**
 * @param {?proto.loopup.ctgateway.v3.PerDdiPurchasedProduct|undefined} value
 * @return {!proto.loopup.ctgateway.v3.AssignPerDdiProductResponse} returns this
*/
proto.loopup.ctgateway.v3.AssignPerDdiProductResponse.prototype.setPurchasedProduct = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.AssignPerDdiProductResponse} returns this
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductResponse.prototype.clearPurchasedProduct = function() {
  return this.setPurchasedProduct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.AssignPerDdiProductResponse.prototype.hasPurchasedProduct = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingEntityId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsRequest}
 */
proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsRequest;
  return proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsRequest}
 */
proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingEntityId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingEntityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string billing_entity_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsRequest.prototype.getBillingEntityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsRequest} returns this
 */
proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsRequest.prototype.setBillingEntityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsRequest} returns this
 */
proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 page_size = 3;
 * @return {number}
 */
proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsRequest} returns this
 */
proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    purchasedProductsList: jspb.Message.toObjectList(msg.getPurchasedProductsList(),
    v3_types_purchased_product_pb.PerSpecifiedQuantityPurchasedProduct.toObject, includeInstance),
    paginationInfo: (f = msg.getPaginationInfo()) && v3_types_pagination_pb.PaginationInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsResponse}
 */
proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsResponse;
  return proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsResponse}
 */
proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v3_types_purchased_product_pb.PerSpecifiedQuantityPurchasedProduct;
      reader.readMessage(value,v3_types_purchased_product_pb.PerSpecifiedQuantityPurchasedProduct.deserializeBinaryFromReader);
      msg.addPurchasedProducts(value);
      break;
    case 2:
      var value = new v3_types_pagination_pb.PaginationInfo;
      reader.readMessage(value,v3_types_pagination_pb.PaginationInfo.deserializeBinaryFromReader);
      msg.setPaginationInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPurchasedProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      v3_types_purchased_product_pb.PerSpecifiedQuantityPurchasedProduct.serializeBinaryToWriter
    );
  }
  f = message.getPaginationInfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      v3_types_pagination_pb.PaginationInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PerSpecifiedQuantityPurchasedProduct purchased_products = 1;
 * @return {!Array<!proto.loopup.ctgateway.v3.PerSpecifiedQuantityPurchasedProduct>}
 */
proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsResponse.prototype.getPurchasedProductsList = function() {
  return /** @type{!Array<!proto.loopup.ctgateway.v3.PerSpecifiedQuantityPurchasedProduct>} */ (
    jspb.Message.getRepeatedWrapperField(this, v3_types_purchased_product_pb.PerSpecifiedQuantityPurchasedProduct, 1));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v3.PerSpecifiedQuantityPurchasedProduct>} value
 * @return {!proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsResponse} returns this
*/
proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsResponse.prototype.setPurchasedProductsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.loopup.ctgateway.v3.PerSpecifiedQuantityPurchasedProduct=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v3.PerSpecifiedQuantityPurchasedProduct}
 */
proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsResponse.prototype.addPurchasedProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.loopup.ctgateway.v3.PerSpecifiedQuantityPurchasedProduct, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsResponse} returns this
 */
proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsResponse.prototype.clearPurchasedProductsList = function() {
  return this.setPurchasedProductsList([]);
};


/**
 * optional PaginationInfo pagination_info = 2;
 * @return {?proto.loopup.ctgateway.v3.PaginationInfo}
 */
proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsResponse.prototype.getPaginationInfo = function() {
  return /** @type{?proto.loopup.ctgateway.v3.PaginationInfo} */ (
    jspb.Message.getWrapperField(this, v3_types_pagination_pb.PaginationInfo, 2));
};


/**
 * @param {?proto.loopup.ctgateway.v3.PaginationInfo|undefined} value
 * @return {!proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsResponse} returns this
*/
proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsResponse.prototype.setPaginationInfo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsResponse} returns this
 */
proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsResponse.prototype.clearPaginationInfo = function() {
  return this.setPaginationInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.ListPerSpecifiedQuantityPurchasedProductsResponse.prototype.hasPaginationInfo = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingEntityId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsRequest}
 */
proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsRequest;
  return proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsRequest}
 */
proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingEntityId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingEntityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string billing_entity_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsRequest.prototype.getBillingEntityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsRequest} returns this
 */
proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsRequest.prototype.setBillingEntityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsRequest} returns this
 */
proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 page_size = 3;
 * @return {number}
 */
proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsRequest} returns this
 */
proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    purchasedProductsList: jspb.Message.toObjectList(msg.getPurchasedProductsList(),
    v3_types_purchased_product_pb.PerDdiPurchasedProduct.toObject, includeInstance),
    paginationInfo: (f = msg.getPaginationInfo()) && v3_types_pagination_pb.PaginationInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsResponse}
 */
proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsResponse;
  return proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsResponse}
 */
proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v3_types_purchased_product_pb.PerDdiPurchasedProduct;
      reader.readMessage(value,v3_types_purchased_product_pb.PerDdiPurchasedProduct.deserializeBinaryFromReader);
      msg.addPurchasedProducts(value);
      break;
    case 2:
      var value = new v3_types_pagination_pb.PaginationInfo;
      reader.readMessage(value,v3_types_pagination_pb.PaginationInfo.deserializeBinaryFromReader);
      msg.setPaginationInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPurchasedProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      v3_types_purchased_product_pb.PerDdiPurchasedProduct.serializeBinaryToWriter
    );
  }
  f = message.getPaginationInfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      v3_types_pagination_pb.PaginationInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PerDdiPurchasedProduct purchased_products = 1;
 * @return {!Array<!proto.loopup.ctgateway.v3.PerDdiPurchasedProduct>}
 */
proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsResponse.prototype.getPurchasedProductsList = function() {
  return /** @type{!Array<!proto.loopup.ctgateway.v3.PerDdiPurchasedProduct>} */ (
    jspb.Message.getRepeatedWrapperField(this, v3_types_purchased_product_pb.PerDdiPurchasedProduct, 1));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v3.PerDdiPurchasedProduct>} value
 * @return {!proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsResponse} returns this
*/
proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsResponse.prototype.setPurchasedProductsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.loopup.ctgateway.v3.PerDdiPurchasedProduct=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v3.PerDdiPurchasedProduct}
 */
proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsResponse.prototype.addPurchasedProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.loopup.ctgateway.v3.PerDdiPurchasedProduct, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsResponse} returns this
 */
proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsResponse.prototype.clearPurchasedProductsList = function() {
  return this.setPurchasedProductsList([]);
};


/**
 * optional PaginationInfo pagination_info = 2;
 * @return {?proto.loopup.ctgateway.v3.PaginationInfo}
 */
proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsResponse.prototype.getPaginationInfo = function() {
  return /** @type{?proto.loopup.ctgateway.v3.PaginationInfo} */ (
    jspb.Message.getWrapperField(this, v3_types_pagination_pb.PaginationInfo, 2));
};


/**
 * @param {?proto.loopup.ctgateway.v3.PaginationInfo|undefined} value
 * @return {!proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsResponse} returns this
*/
proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsResponse.prototype.setPaginationInfo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsResponse} returns this
 */
proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsResponse.prototype.clearPaginationInfo = function() {
  return this.setPaginationInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.ListPerDdiPurchasedProductsResponse.prototype.hasPaginationInfo = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingEntityId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsRequest}
 */
proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsRequest;
  return proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsRequest}
 */
proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingEntityId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingEntityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string billing_entity_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsRequest.prototype.getBillingEntityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsRequest} returns this
 */
proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsRequest.prototype.setBillingEntityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsRequest} returns this
 */
proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 page_size = 3;
 * @return {number}
 */
proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsRequest} returns this
 */
proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    purchasedProductsList: jspb.Message.toObjectList(msg.getPurchasedProductsList(),
    v3_types_purchased_product_pb.PerCallDurationPurchasedProduct.toObject, includeInstance),
    paginationInfo: (f = msg.getPaginationInfo()) && v3_types_pagination_pb.PaginationInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsResponse}
 */
proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsResponse;
  return proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsResponse}
 */
proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v3_types_purchased_product_pb.PerCallDurationPurchasedProduct;
      reader.readMessage(value,v3_types_purchased_product_pb.PerCallDurationPurchasedProduct.deserializeBinaryFromReader);
      msg.addPurchasedProducts(value);
      break;
    case 2:
      var value = new v3_types_pagination_pb.PaginationInfo;
      reader.readMessage(value,v3_types_pagination_pb.PaginationInfo.deserializeBinaryFromReader);
      msg.setPaginationInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPurchasedProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      v3_types_purchased_product_pb.PerCallDurationPurchasedProduct.serializeBinaryToWriter
    );
  }
  f = message.getPaginationInfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      v3_types_pagination_pb.PaginationInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PerCallDurationPurchasedProduct purchased_products = 1;
 * @return {!Array<!proto.loopup.ctgateway.v3.PerCallDurationPurchasedProduct>}
 */
proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsResponse.prototype.getPurchasedProductsList = function() {
  return /** @type{!Array<!proto.loopup.ctgateway.v3.PerCallDurationPurchasedProduct>} */ (
    jspb.Message.getRepeatedWrapperField(this, v3_types_purchased_product_pb.PerCallDurationPurchasedProduct, 1));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v3.PerCallDurationPurchasedProduct>} value
 * @return {!proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsResponse} returns this
*/
proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsResponse.prototype.setPurchasedProductsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.loopup.ctgateway.v3.PerCallDurationPurchasedProduct=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v3.PerCallDurationPurchasedProduct}
 */
proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsResponse.prototype.addPurchasedProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.loopup.ctgateway.v3.PerCallDurationPurchasedProduct, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsResponse} returns this
 */
proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsResponse.prototype.clearPurchasedProductsList = function() {
  return this.setPurchasedProductsList([]);
};


/**
 * optional PaginationInfo pagination_info = 2;
 * @return {?proto.loopup.ctgateway.v3.PaginationInfo}
 */
proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsResponse.prototype.getPaginationInfo = function() {
  return /** @type{?proto.loopup.ctgateway.v3.PaginationInfo} */ (
    jspb.Message.getWrapperField(this, v3_types_pagination_pb.PaginationInfo, 2));
};


/**
 * @param {?proto.loopup.ctgateway.v3.PaginationInfo|undefined} value
 * @return {!proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsResponse} returns this
*/
proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsResponse.prototype.setPaginationInfo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsResponse} returns this
 */
proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsResponse.prototype.clearPaginationInfo = function() {
  return this.setPaginationInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.ListPerCallDurationPurchasedProductsResponse.prototype.hasPaginationInfo = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingEntityId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    purchasedProductId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    amount: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    effectiveFromDateTime: (f = msg.getEffectiveFromDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest}
 */
proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest;
  return proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest}
 */
proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingEntityId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPurchasedProductId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAmount(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEffectiveFromDateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingEntityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPurchasedProductId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getEffectiveFromDateTime();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string billing_entity_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest.prototype.getBillingEntityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest} returns this
 */
proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest.prototype.setBillingEntityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string purchased_product_id = 2;
 * @return {string}
 */
proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest.prototype.getPurchasedProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest} returns this
 */
proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest.prototype.setPurchasedProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional double amount = 3;
 * @return {number}
 */
proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest} returns this
 */
proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest.prototype.setAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp effective_from_date_time = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest.prototype.getEffectiveFromDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest} returns this
*/
proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest.prototype.setEffectiveFromDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest} returns this
 */
proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest.prototype.clearEffectiveFromDateTime = function() {
  return this.setEffectiveFromDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.AddBillingAdjustmentRequest.prototype.hasEffectiveFromDateTime = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.AddBillingAdjustmentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.AddBillingAdjustmentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.AddBillingAdjustmentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.AddBillingAdjustmentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingAdjustment: (f = msg.getBillingAdjustment()) && v3_types_billing_adjustment_pb.BillingAdjustment.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.AddBillingAdjustmentResponse}
 */
proto.loopup.ctgateway.v3.AddBillingAdjustmentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.AddBillingAdjustmentResponse;
  return proto.loopup.ctgateway.v3.AddBillingAdjustmentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.AddBillingAdjustmentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.AddBillingAdjustmentResponse}
 */
proto.loopup.ctgateway.v3.AddBillingAdjustmentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v3_types_billing_adjustment_pb.BillingAdjustment;
      reader.readMessage(value,v3_types_billing_adjustment_pb.BillingAdjustment.deserializeBinaryFromReader);
      msg.setBillingAdjustment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.AddBillingAdjustmentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.AddBillingAdjustmentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.AddBillingAdjustmentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.AddBillingAdjustmentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingAdjustment();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      v3_types_billing_adjustment_pb.BillingAdjustment.serializeBinaryToWriter
    );
  }
};


/**
 * optional BillingAdjustment billing_adjustment = 1;
 * @return {?proto.loopup.ctgateway.v3.BillingAdjustment}
 */
proto.loopup.ctgateway.v3.AddBillingAdjustmentResponse.prototype.getBillingAdjustment = function() {
  return /** @type{?proto.loopup.ctgateway.v3.BillingAdjustment} */ (
    jspb.Message.getWrapperField(this, v3_types_billing_adjustment_pb.BillingAdjustment, 1));
};


/**
 * @param {?proto.loopup.ctgateway.v3.BillingAdjustment|undefined} value
 * @return {!proto.loopup.ctgateway.v3.AddBillingAdjustmentResponse} returns this
*/
proto.loopup.ctgateway.v3.AddBillingAdjustmentResponse.prototype.setBillingAdjustment = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.AddBillingAdjustmentResponse} returns this
 */
proto.loopup.ctgateway.v3.AddBillingAdjustmentResponse.prototype.clearBillingAdjustment = function() {
  return this.setBillingAdjustment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.AddBillingAdjustmentResponse.prototype.hasBillingAdjustment = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.RemoveBillingAdjustmentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.RemoveBillingAdjustmentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.RemoveBillingAdjustmentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.RemoveBillingAdjustmentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingEntityId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    adjustmentId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.RemoveBillingAdjustmentRequest}
 */
proto.loopup.ctgateway.v3.RemoveBillingAdjustmentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.RemoveBillingAdjustmentRequest;
  return proto.loopup.ctgateway.v3.RemoveBillingAdjustmentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.RemoveBillingAdjustmentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.RemoveBillingAdjustmentRequest}
 */
proto.loopup.ctgateway.v3.RemoveBillingAdjustmentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingEntityId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdjustmentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.RemoveBillingAdjustmentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.RemoveBillingAdjustmentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.RemoveBillingAdjustmentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.RemoveBillingAdjustmentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingEntityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAdjustmentId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string billing_entity_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.RemoveBillingAdjustmentRequest.prototype.getBillingEntityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.RemoveBillingAdjustmentRequest} returns this
 */
proto.loopup.ctgateway.v3.RemoveBillingAdjustmentRequest.prototype.setBillingEntityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string adjustment_id = 2;
 * @return {string}
 */
proto.loopup.ctgateway.v3.RemoveBillingAdjustmentRequest.prototype.getAdjustmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.RemoveBillingAdjustmentRequest} returns this
 */
proto.loopup.ctgateway.v3.RemoveBillingAdjustmentRequest.prototype.setAdjustmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.RemoveBillingAdjustmentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.RemoveBillingAdjustmentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.RemoveBillingAdjustmentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.RemoveBillingAdjustmentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.RemoveBillingAdjustmentResponse}
 */
proto.loopup.ctgateway.v3.RemoveBillingAdjustmentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.RemoveBillingAdjustmentResponse;
  return proto.loopup.ctgateway.v3.RemoveBillingAdjustmentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.RemoveBillingAdjustmentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.RemoveBillingAdjustmentResponse}
 */
proto.loopup.ctgateway.v3.RemoveBillingAdjustmentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.RemoveBillingAdjustmentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.RemoveBillingAdjustmentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.RemoveBillingAdjustmentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.RemoveBillingAdjustmentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.RemoveBillingEntityRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.RemoveBillingEntityRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.RemoveBillingEntityRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.RemoveBillingEntityRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingEntityId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.RemoveBillingEntityRequest}
 */
proto.loopup.ctgateway.v3.RemoveBillingEntityRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.RemoveBillingEntityRequest;
  return proto.loopup.ctgateway.v3.RemoveBillingEntityRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.RemoveBillingEntityRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.RemoveBillingEntityRequest}
 */
proto.loopup.ctgateway.v3.RemoveBillingEntityRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingEntityId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.RemoveBillingEntityRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.RemoveBillingEntityRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.RemoveBillingEntityRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.RemoveBillingEntityRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingEntityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string billing_entity_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.RemoveBillingEntityRequest.prototype.getBillingEntityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.RemoveBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v3.RemoveBillingEntityRequest.prototype.setBillingEntityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.RemoveBillingEntityResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.RemoveBillingEntityResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.RemoveBillingEntityResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.RemoveBillingEntityResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.RemoveBillingEntityResponse}
 */
proto.loopup.ctgateway.v3.RemoveBillingEntityResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.RemoveBillingEntityResponse;
  return proto.loopup.ctgateway.v3.RemoveBillingEntityResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.RemoveBillingEntityResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.RemoveBillingEntityResponse}
 */
proto.loopup.ctgateway.v3.RemoveBillingEntityResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.RemoveBillingEntityResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.RemoveBillingEntityResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.RemoveBillingEntityResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.RemoveBillingEntityResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.loopup.ctgateway.v3);
